import React from 'react'
import slice from 'lodash/slice'
import * as Collapsible from '@radix-ui/react-collapsible'
import { RowSpacingIcon, Cross2Icon } from '@radix-ui/react-icons'
import { forCategory, RegionsFilter } from './RegionsFilter'
import regions from '../data/regions.json'

const Categories = () => {
  const [open, setOpen] = React.useState(false)

  const count = 9
  const provinces = Object.entries(regions.中国).map((x) => x[0])
  const defaults = slice(provinces, 0, count)
  const hiddens = slice(provinces, count)

  return (
    <>
      <div className="sidebar">
        <Collapsible.Root open={open} onOpenChange={setOpen}>
          <div className="regions">
            <RegionsFilter regions={defaults} buildUrl={forCategory} />
          </div>
          <Collapsible.Content>
            <div className="regions">
              <RegionsFilter regions={hiddens} buildUrl={forCategory} />
            </div>
          </Collapsible.Content>

          <div style={{ textAlign: 'right', marginTop: '0.5rem' }}>
            <Collapsible.Trigger asChild>
              <button className="icon-button">
                {open ? <Cross2Icon /> : <RowSpacingIcon />}
              </button>
            </Collapsible.Trigger>
          </div>
        </Collapsible.Root>
      </div>
    </>
  )
}

export default Categories
